var _ellipse, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning3 = function SvgWarning3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 161"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 130.061,
    fill: "#ACADAD",
    rx: 60,
    ry: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.061,
    r: 60,
    fill: "#FFC43A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.674 50.06h8.714c1.563 0 2.825 1.503 2.705 3.186L84.088 86.48c-.06.901-.781 1.622-1.623 1.622h-4.688c-.84 0-1.562-.721-1.622-1.622L72.97 53.306c-.12-1.743 1.082-3.245 2.704-3.245zm4.387 61.24c-3.846 0-7.031-3.125-7.031-7.032 0-3.846 3.185-7.03 7.031-7.03 3.906 0 7.032 3.184 7.032 7.03a7.002 7.002 0 0 1-7.032 7.032z"
  })));
};
export { SvgWarning3 as ReactComponent };
export default __webpack_public_path__ + "assets/warning-3.svg";